import { PeriodLayout } from "./periodLayout";
import { MenuItem, TextField } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { RulePeriodSelector } from "./ruleParameters";

const periodOptions: { label: string; selector: RulePeriodSelector }[] = [
  {
    label: "autoAllPeriods",
    selector: { is_deployable: null, position: "all" },
  },
  {
    label: "autoFirstPeriod",
    selector: { is_deployable: null, position: "first" },
  },
  {
    label: "autoLastPeriod",
    selector: { is_deployable: null, position: "last" },
  },
  {
    label: "autoAllDeployablePeriods",
    selector: { is_deployable: true, position: "all" },
  },
  {
    label: "autoFirstDeployablePeriod",
    selector: { is_deployable: true, position: "first" },
  },
  {
    label: "autoLastDeployablePeriod",
    selector: { is_deployable: true, position: "last" },
  },
  {
    label: "autoAllForecastPeriods",
    selector: { is_deployable: false, position: "all" },
  },
  {
    label: "autoFirstForecastPeriod",
    selector: { is_deployable: false, position: "first" },
  },
  {
    label: "autoLastForecastPeriod",
    selector: { is_deployable: false, position: "last" },
  },
];
export const PeriodRuleControls = ({
  periodLayout,
  selector,
  onChange,
  disabled,
}: {
  periodLayout: PeriodLayout;
  selector: RulePeriodSelector;
  onChange: (selector: RulePeriodSelector) => void;
  disabled: boolean;
}) => {
  const { t } = useTenantTranslation();
  const selected = periodOptions.find(
    (option) =>
      option.selector.is_deployable === selector.is_deployable &&
      option.selector.position === selector.position
  );
  const availableOptions = periodOptions.filter(({ selector: candidate }) => {
    const maximum =
      candidate.is_deployable === null
        ? periodLayout.deployable.maximum === null ||
          periodLayout.forecast.maximum === null
          ? null
          : periodLayout.deployable.maximum + periodLayout.forecast.maximum
        : (candidate.is_deployable
            ? periodLayout.deployable
            : periodLayout.forecast
          ).maximum;
    if (maximum === 0) return false;
    if (candidate.is_deployable !== null && periodLayout.forecast.maximum === 0)
      return false;
    return candidate.position === "all" || maximum === null || maximum > 1;
  });
  const applicableSelected =
    availableOptions.find((option) => option === selected) ??
    (selector.is_deployable === true && periodLayout.forecast.maximum === 0
      ? availableOptions.find(
          ({ selector: candidate }) => candidate.position === selector.position
        )
      : undefined);
  const displayedOptions =
    selected && !applicableSelected
      ? [...availableOptions, selected]
      : availableOptions;
  return (
    <TextField
      select
      size="small"
      label={t("autoApplyToPeriods")}
      value={applicableSelected?.label ?? selected?.label ?? ""}
      disabled={disabled}
      sx={{ minWidth: 230 }}
      onChange={(event) => {
        const option = periodOptions.find(
          (option) => option.label === event.target.value
        );
        if (option) onChange(option.selector);
      }}
    >
      {displayedOptions.map((option) => (
        <MenuItem
          key={option.label}
          value={option.label}
          disabled={!availableOptions.includes(option)}
        >
          {t(option.label)}
        </MenuItem>
      ))}
    </TextField>
  );
};
